<template>
  <v-tabs>
    <v-tab><h2>瀏覽</h2></v-tab>
    <v-tab-item class="pa-1 pa-sm-4">
      <!-- Save & Reset Buttons -->
      <v-row>
        <v-col sm="12" md="9" class="text-end">
          <v-btn
            class="ma-2"
            elevation="4"
            color="success"
            @click="handleOnNewAddOne"
          >
            <v-icon>mdi-plus-thick</v-icon>
          </v-btn>
          <v-btn
            class="ma-2"
            elevation="4"
            color="error"
            @click="handleOnDeleteAddOne"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- Table -->
      <v-row>
        <v-col sm="12" md="9" class="pr-xs-1">
          <v-data-table
            :headers="headers"
            item-key="board_id"
            :items="!isSending ? boards : []"
            class="elevation-4 my-board-table"
            :search="tableSearch"
            :loading="isSending"
            loading-text="資料更新中..."
            no-data-text="暫無資料"
            no-results-text="沒有匹配的資料"
            show-select
            v-model="tableCBSelected"
            :mobile-breakpoint="tableModes[tableMode].breakpoint"
          >
            <template v-slot:item.enb="{ item }">
              {{ item.enb ? '啟用' : '關閉' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" @click="handleOnEditAddOne(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-tab-item>
    <!-- Dialog -->
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{
              dialogMode ? '新增公告' : '編輯公告'
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                text
                @click="handleOnDialogSave"
                :disabled="isSending"
              >
                <h2>儲存</h2>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <!--  -->
          <v-row class="pa-2">
            <v-col>
              <v-text-field
                v-model="boardName"
                label="公告名稱"
                :rules="dialogInputRules"
                :counter="10"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-switch
                v-model="enb"
                inset
                color="primary"
                :label="`狀態:${enb ? '啟用' : '關閉'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <!-- Table -->

          <!-- Editor -->
          <v-row>
            <v-spacer></v-spacer>
            <v-progress-linear
              :active="isSending"
              indeterminate
              bottom
            ></v-progress-linear>
          </v-row>
          <v-row class="pa-2">
            <v-col>
              <quillEditor
                style="height:350px;"
                v-model="content"
                :options="editorOption"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>
  </v-tabs>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { quillEditor, Quill } from 'vue-quill-editor'
import ImageResize from 'quill-image-resize-module'
import ImageUploader from 'quill-image-uploader'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Quill.register('modules/imageResize', ImageResize)
Quill.register('modules/imageUploader', ImageUploader)

export default {
  data: () => ({
    // Dialog
    dialog: false,
    dialogMode: true,
    dialogOnSaveFn: undefined,
    dialogInputRules: [
      v => !!v || '不可空白',
      v => v.length <= 10 || '不可超過10個字'
    ],
    //
    boardName: '',
    enb: '',
    // Editor
    content: '',
    editorOption: {
      modules: {
        imageResize: {
          // displayStyles: {
          //   backgroundColor: 'black',
          //   border: 'none',
          //   color: 'white'
          // },
          modules: ['Resize', 'DisplaySize', 'Toolbar']
        },
        imageUploader: {
          upload: file => {
            //
            return new Promise((resolve, reject) => {
              const path = 'uploadImage.php'
              const topPath =
                process.env.NODE_ENV === 'development'
                  ? `http://localhost/p221001/public/images/`
                  : `images/`
              const url = topPath + path
              const formData = new FormData()
              formData.append('image', file)

              // formData.append('user', this.user)
              // formData.append('uid', this.uid)

              fetch(url, { method: 'POST', body: formData })
                .then(response => response.text())
                .then(text => {
                  resolve(topPath + text)
                })
                .catch(error => {
                  reject('Upload failed')
                  if (process.env.NODE_ENV === 'development')
                    // eslint-disable-next-line no-console
                    console.log('Error:', error)
                })
            })
          }
        },
        toolbar: [
          [{ font: [] }],
          [{ size: ['small', false, 'large', 'huge'] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ header: 1 }, { header: 2 }],
          [{ color: [] }, { background: [] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ align: [] }],
          ['link', 'image', 'video']
        ]
      },
      placeholder: '請輸入內容'
    },
    // #region Table
    tableSearch: '',
    tableCBSelected: [],
    headers: [
      {
        text: '名稱',
        align: 'start',
        value: 'name'
      },
      {
        text: '狀態',
        align: 'start',
        value: 'enb'
      },
      {
        text: '更新時間',
        align: 'start',
        value: 'update_time'
      },
      {
        text: '',
        align: 'end',
        value: 'actions'
      }
    ],
    // #endregion
    nothing: undefined
  }),
  components: {
    quillEditor
  },
  computed: {
    ...mapState('account', ['uid', 'user']),
    ...mapState('admin', ['tableModes', 'tableMode', 'isSending', 'boards'])
  },
  methods: {
    ...mapActions('admin', [
      'addBoard',
      'getAllBoards',
      'updateBoard',
      'deleteBoard'
    ]),
    handleOnNewAddOne() {
      this.boardName = ''
      this.enb = true
      this.content = ''
      this.dialog = true
      this.dialogOnSaveFn = async () => {
        if (!this.boardName) return
        if (!this.content) return
        const { content, user, uid } = this
        await this.addBoard({
          name: this.boardName.trim(),
          enb: this.enb ? 1 : 0,
          content,
          user,
          uid
        })
        this.dialog = false
      }
    },
    // eslint-disable-next-line no-unused-vars
    handleOnEditAddOne(item) {
      this.boardName = item.name
      this.enb = item.enb
      this.content = item.content
      this.dialog = true
      this.dialogOnSaveFn = async () => {
        if (!this.boardName) return
        if (!this.content) return
        const { content, user, uid } = this
        await this.updateBoard({
          id: item.board_id,
          name: this.boardName.trim(),
          enb: this.enb ? 1 : 0,
          content,
          user,
          uid
        })
        this.dialog = false
      }
    },
    handleOnDeleteAddOne() {
      if (this.tableCBSelected.length < 1) return
      if (!confirm('確定刪除嗎?')) return
      const ids = []
      this.tableCBSelected.forEach(e => {
        ids.push(e.board_id)
      })
      const { user, uid } = this
      this.deleteBoard({
        ids: JSON.stringify(ids),
        user,
        uid
      })
    },
    // Dialog
    handleOnDialogSave() {
      if (this.dialogOnSaveFn) this.dialogOnSaveFn()
    },
    // Editor
    onEditorChange({ quill, html, text }) {
      if (process.env.NODE_ENV === 'development')
        // eslint-disable-next-line no-console
        console.log('editor change!', quill, html, text)
    }
  },
  async created() {
    this.$emit('setTopLabel', 1)

    const { uid, user } = this
    await this.getAllBoards({ uid, user })
  },
  nothing: undefined
}
</script>

<style lang="scss">
.my-board-table {
  th,
  td {
    font-size: 18px;
  }
}

@media screen and (max-width: 600px) {
  .my-board-table {
    th,
    td {
      padding-right: 2px !important;
      padding-left: 2px !important;
    }

    .v-data-footer {
      .v-data-footer__select {
        margin-right: 0px;
      }
    }
  }
}
</style>
